import React from "react";

const Intro = () => {
  return (
    <div className="tool__intro">
      <h4 className="tool__header">Our Graphics</h4>
      <p>Select a graphic to add it to your product:</p>
    </div>
  );
};

export default Intro;
